import React from 'react';
import {Flex, Icon, PriorityIcon, Separator, Text} from '@priority-software/priority-style-react';
import styles from '../styles/newArea.module.scss';
import texts from '../texts';

export const NewArea = ({onClick}) => {
    return (
        <div onClick={onClick}>
            <Flex justifyContent="flex-end" componentClasses={styles.spaceIndicationConatiner}>
                <Separator align="vertical" height={1} componentClasses={styles.spaceIndication} />
                <Flex componentClasses={styles.hoveredSplitter}>
                    <Text skin="paragraph-2">{texts.removeSpace}</Text>
                    <Icon icon={PriorityIcon.delete} iconColor="secondary-500" />
                </Flex>
            </Flex>
        </div>
    );
};
